import React, { Fragment } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
} from "@mui/material";
import { FontFamily, Images } from "assets";
import Colors from "assets/Style/Colors";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const shadowBox = {
  bgcolor: "transparent",
  width: "100%",
  height: "100%",
  position: "absolute",
  left: "0px",
  top: "0px",
  opacity: "1",
  boxShadow:
    "rgba(0, 0, 0, 0.1) 0rem 0.25rem 0.375rem -0.0625rem, rgba(0, 0, 0, 0.06) 0rem 0.125rem 0.25rem -0.0625rem",
  transform: "scale(0.94)",
  filter: "blur(12px)",
  borderRadius: 4,
};

const blogTextStyle = {
  "-webkit-line-clamp": "6",
  "-webkit-box-orient": "vertical",
  display: "-webkit-box",
  overflow: "hidden",
  textOverflow: "ellipsis",
  wordBreak: "break-all",
  color: Colors.smokeyGrey,
  fontFamily: FontFamily.NunitoRegular,
  mb: 2,
};

function BuyACar() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Fragment>
      <Box
        sx={{
          position: "relative",
          overflow: "hidden",
          width: 1,
          height: 500,
          bgcolor: Colors.mirage,
          backgroundColor: "rgba(0,0,0,0.9)",
        }}
      >
        <Box
          component="img"
          src={Images.buyCarBanner}
          alt={t("buyACarPage.hero.bannerAlt")}
          style={{
            objectFit: "cover",
            position: "absolute",
            width: "100%",
            height: "500px",
            left: 0,
            top: 0,
            opacity: "0.4",
          }}
        />
        <Container
          style={{
            backgroundColor: "transparent",
          }}
        >
          <Box
            sx={{
              marginTop: "10%",
              backgroundColor: "transparent",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              alignSelf: "center",
            }}
          >
            <Grid container spacing={0}>
              <Grid item xs={12} sm={12} md={12} sx={{ zIndex: 5 }}>
                <Typography
                  //   variant="h1"
                  letterSpacing={5}
                  sx={{
                    textTransform: "capitalize",
                    textAlign: "center",
                    fontSize: 20,
                    color: "#5BBC0F",
                  }}
                >
                  {t("buyACarPage.hero.tagline")}
                </Typography>
                <Typography
                  variant="h1"
                  sx={{
                    textTransform: "capitalize",
                    textAlign: "center",
                    // fontSize: 20,
                  }}
                >
                  {t("buyACarPage.hero.companyName")}
                </Typography>
                <Box
                  md={12}
                  sx={{
                    borderWidth: 5,
                    border: "solid",
                    width: "80%",
                    borderColor: Colors.lightGreen,
                    justifyContent: "center",
                    display: "flex",
                    mt: 2,
                    ml: 15,
                  }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    textAlign: "center",
                    color: Colors.white,
                    px: 26.5,
                    fontFamily: FontFamily.NunitoRegular,
                    mt: 2,
                  }}
                >
                  {t("buyACarPage.hero.description")}
                </Typography>
              </Grid>
            </Grid>

            {/* <Grid container spacing={0}>
              <Grid item xs={12} sm={8} md={8} sx={{ zIndex: 5 }}>
                <Typography variant="h1" sx={{ textTransform: "capitalize" }}>
                  Buy a Car
                </Typography>
              </Grid>
            </Grid> */}
          </Box>
        </Container>
      </Box>

      <Box sx={{ py: 5, mt: 0, mb: 4 }}>
        <Container>
          <Typography
            variant="h1"
            sx={{
              textAlign: "center",
              fontSize: 44,
              fontWeight: "700px",
              fontFamily: FontFamily.NunitoRegular,
              color: Colors.black,
            }}
          >
            {t("buyACarPage.cta.title")}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              textAlign: "center",
              color: "rgba(0,0,0,0.6)",
              px: 21,
              fontFamily: FontFamily.NunitoRegular,
              mt: 3,
            }}
          >
            {t("buyACarPage.cta.description")}
          </Typography>
          <Box
            component="img"
            src={Images.buyCarlogo}
            alt={t("buyACarPage.cta.logoAlt")}
            style={{
              objectFit: "cover",
              width: "20%",
              height: "200px",
              display: "block",
              margin: "auto",
            }}
          />
        </Container>
      </Box>
    </Fragment>
  );
}

export default BuyACar;
